import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.number.constructor";
import Vue from "vue";
import sourcePreview from "components/SourcePreview.vue";
import { GetSourceList, GetSourceInfo, GetPartnerSource, GetSchoolSource } from "api/v1.design.courseware";
import { saveCourseProcessCellDoc } from "api/v1.faceteachactivity";
import { Message } from "element-ui";
import PreparingCourseware from "components/PreparingCourseware.vue";
import SourceListToSchool from "components/SourceListToSchool.vue";
import SourceListToPartner from "components/SourceListToPartner.vue";
export default Vue.extend({
  components: {
    SourceListToSchool: SourceListToSchool,
    SourceListToPartner: SourceListToPartner,
    "source-preview": sourcePreview,
    PreparingCourseware: PreparingCourseware
  },
  data: function data() {
    return {
      radio: "",
      files: [],
      label: "课件",
      pageSize: 8,
      pageIndex: 1,
      totalCount: 0,
      name: "source",
      list: [],
      nodePathList: [],
      tabPosition: "top",
      isShow_source: true,
      courseName: "22",
      newFolderId: "",
      dataCount: 1,
      folderId: "",
      sourceIds: [],
      checkedList: [],
      sourceId: "",
      checks: [],
      sourceUrl: {
        id: "",
        url: "",
        type: "",
        docName: "",
        docType: 0
      },
      disabled: false,
      checkStatus: false,
      checkArr: [],
      dialogVisiblePreviewResources: false,
      activeName: "source",
      IsScourseList: true
    };
  },
  props: {
    courseId: {
      type: String,
      default: ""
    },
    topicId: {
      type: String,
      default: ""
    },
    cellLevel: {
      type: String,
      default: ""
    },
    cellId: {
      type: String,
      default: ""
    },
    parentId: {
      type: String,
      default: ""
    },
    cellName: {
      type: String,
      default: ""
    },
    cellContent: {
      type: String,
      default: ""
    },
    maxSortOrder: {
      type: Number,
      default: 0
    },
    activityIds: {},
    faceId: {
      type: String,
      default: ""
    },
    classId: {
      type: String,
      default: ""
    },
    createIn: {
      type: Number,
      default: 0
    },
    faceTeachState: {
      default: ""
    }
  },
  created: function created() {
    this.getSourceList("source", 1);
  },
  watch: {},
  methods: {
    handleClick: function handleClick(event) {
      this.activeName = event.name;
      this.list = [];
      this.totalCount = 0;
      this.pageSize = 8;
      this.courseName = "";
      this.nodePathList = [];
      this.dataCount = 1;
      this.folderId = "0";

      if (this.activeName == "source") {
        this.getSourceList("source", 1);
        this.IsScourseList = true;
      } else if (this.activeName == "partner") {
        this.IsScourseList = false; // this.getPartnerSource(1);
      } else if (this.activeName == "school") {
        // this.getSchoolSource(1);
        this.IsScourseList = false;
      }
    },
    dialogClose: function dialogClose() {
      this.dialogVisiblePreviewResources = false;
    },
    getSourceList: function getSourceList(type, page) {
      var _this = this;

      this.$nextTick(function () {
        GetSourceList(_this.courseId, _this.folderId, type, page).then(function (rst) {
          _this.list = rst.list;
          _this.totalCount = rst.pagination.totalCount;
          _this.pageSize = rst.pagination.pageSize;
          _this.courseName = rst.courseName;
          _this.nodePathList = rst.nodePathList;
          _this.dataCount = rst.dataCount;
          console.log(_this.list);
          rst.list.forEach(function (item) {
            _this.$set(_this.checkedList, item.Id, false);
          });
        });
      });
    },
    getPartnerSource: function getPartnerSource(page) {
      var _this2 = this;

      this.$nextTick(function () {
        GetPartnerSource(_this2.folderId, page).then(function (rst) {
          _this2.list = rst.list;
          _this2.totalCount = rst.pagination.totalCount;
          _this2.pageSize = rst.pagination.pageSize;
          _this2.courseName = rst.courseName;
          _this2.nodePathList = rst.nodePathList;
          _this2.dataCount = rst.dataCount;
          console.log(_this2.list);
          rst.list.forEach(function (item) {
            _this2.$set(_this2.checkedList, item.Id, false);
          });
        });
      });
    },
    getSchoolSource: function getSchoolSource(page) {
      var _this3 = this;

      this.$nextTick(function () {
        GetSchoolSource(_this3.folderId, page).then(function (rst) {
          _this3.list = rst.list;
          _this3.totalCount = rst.pagination.totalCount;
          _this3.pageSize = rst.pagination.pageSize;
          _this3.courseName = rst.courseName;
          _this3.nodePathList = rst.nodePathList;
          _this3.dataCount = rst.dataCount;
          console.log(_this3.list);
          rst.list.forEach(function (item) {
            _this3.$set(_this3.checkedList, item.Id, false);
          });
        });
      });
    },
    clickFolderHander: function clickFolderHander(newFolderId) {
      this.folderId = newFolderId;
      var pageIndex = this.list.pageIndex;

      if (this.activeName == "source") {
        this.getSourceList("source", pageIndex);
        this.IsScourseList = true;
      } else if (this.activeName == "partner") {
        // this.getPartnerSource(pageIndex);
        this.IsScourseList = false;
      } else if (this.activeName == "school") {
        // this.getSchoolSource(pageIndex);
        this.IsScourseList = false;
      }
    },
    previewImage: function previewImage(Id, url, type) {
      var _this4 = this;

      if (type == ".zip" || type == ".rar" || type == "7z") {
        this.$message("压缩包不支持预览");
      } else {
        if (type != "") {
          this.sourceId = Id;
          this.dialogVisiblePreviewResources = true;
        }

        GetSourceInfo(Id).then(function (rst) {
          console.log(rst);

          if (rst.status == -1) {
            Message.warning("文件转换失败不能预览");
          } else if (rst.status == -2) {
            Message.warning("文件正在转换请稍后预览");
          } else if (rst.status == 1) {
            _this4.sourceUrl = {
              id: Id,
              url: rst.docPriviewUrl,
              type: type,
              docName: rst.docName,
              docType: rst.docType
            };
          }
        });
      }
    },
    onPageChangeHandler: function onPageChangeHandler(page) {
      if (this.activeName == "source") {
        this.getSourceList("source", page);
        this.IsScourseList = true;
      } else if (this.activeName == "partner") {
        // this.getPartnerSource(page);
        this.IsScourseList = false;
      } else if (this.activeName == "school") {
        // this.getSchoolSource(page);
        this.IsScourseList = false;
      }
    },
    handleSelectionChange: function handleSelectionChange(Id) {
      this.radio; // this.checkedList[0] = Id;
      // if (!this.checkedList[Id]) {
      //   this.checkedList[Id] = false;
      //   var index = this.sourceIds.indexOf(Id);
      //   this.sourceIds.splice(index, 1);
      // } else {
      //   this.checkedList[Id] = true;
      //   this.sourceIds.push(Id);
      // }

      this.sourceIds = this.radio;
      console.log(this.sourceIds);
      this.$emit('onClickId', this.sourceIds);
    },
    handleSelectionClick: function handleSelectionClick(Id, check) {
      if (check == true) {
        this.radio = "";
      } else {
        // this.sourceIds.push(Id);
        this.radio = Id;
      }

      console.log(this.radio);
      this.$emit('onClickId', this.radio);
    },
    importSource: function importSource() {
      var _this5 = this;

      if (this.sourceIds.length == 0) {
        this.$message.warning("请选择课件！");
      } else {
        saveCourseProcessCellDoc(this.courseId, this.topicId, this.parentId, this.maxSortOrder, this.sourceIds).then(function (rst) {
          if (rst.code > 0) {
            var list = rst.cellList;

            _this5.$message.success(rst.msg);
          } else {
            _this5.$message({
              type: "warning",
              message: rst.msg
            });
          }

          var checkLength = _this5.list.length;

          for (var i = 0; i < checkLength; i++) {
            if (_this5.list[i].checked) {
              if (_this5.list[i].checked == true) {
                _this5.list[i].checked = false;
              }
            }
          }

          _this5.sourceIds = [];

          _this5.$emit("closeDialog", true, list);
        });
      }

      this.disabled = false;
      this.checkStatus = true;
    }
  }
});